export function updateEditor (list, oldEditor) {
  list = list || []
  let same = list.length === oldEditor.length - 1
  if (same) {
    same = oldEditor[list.length].temporary
    for (let i = 0; i < list.length; i++) {
      if (list[i] !== oldEditor[i].value || oldEditor[i].temporary) {
        same = false
      }
    }
  }
  if (same) {
    return oldEditor
  }
  let newEditor = [], value2key = {}, temporary = null
  for (let item of oldEditor) {
    if (item.temporary) {
      temporary = item
    } else if (item.value in value2key) {
      value2key[item.value] = null
    } else {
      value2key[item.value] = item.key
    }
  }
  for (let i = 0; i < list.length; i++) {
    let value = list[i]
    newEditor.push({
      key: value2key[value] || Math.random() + '',
      value: value,
    })
  }
  newEditor.push(temporary || {
    value: '',
    key: Math.random() + '',
    temporary: true,
  })
  return newEditor
}

export function editorUpdated (oldList, editor) {
  oldList = oldList || []
  let temporary = editor.find(v => v.temporary)
  if (temporary && temporary.value) {
    delete temporary.temporary
    temporary = null
  }
  if (!temporary) {
    editor.push({
      value: '',
      key: Math.random() + '',
      temporary: true,
    })
  }
  let same = oldList.length === editor.length - 1
  if (same) {
    for (let i = 0; i < oldList.length; i++) {
      if (oldList[i] !== editor[i].value) {
        same = false
      }
    }
  }
  if (same) {
    return oldList
  }
  let newList = []
  for (let i = 0; i < editor.length - 1; i++) {
    newList.push(editor[i].value)
  }
  return newList
}

export function deleteKey (editor, key) {
  for (let i = 0; i < editor.length; i++) {
    if (editor[i].key === key && !editor[i].temporary) {
      editor.splice(i, 1)
      return
    }
  }
  throw new TypeError('key "' + key + '" not found')
}

export function duplicateValueRule (editor, key, message) {
  return {
    validator: (rule, value, callback) => {
      if (!value) return callback()
      for (let item of editor) {
        if (item.value === value && item.key !== key) {
          return callback(new Error(message || 'Duplicate value'))
        }
      }
      return callback()
    },
  }
}

export function emptyEditor () {
  return [{
    value: '',
    key: Math.random() + '',
    temporary: true,
  }]
}
